import type { ClientPayload, ClientSource, NoteVisibility } from './types';

export const SOURCE_LABELS: Record<ClientSource, string> = {
  walk_in: 'Vino al local',
  referral: 'Recomendación',
  social: 'Redes sociales',
  online: 'Reserva en línea',
  other: 'Otro',
};

export const VISIBILITY_LABELS: Record<NoteVisibility, string> = {
  all_staff: 'Todo el personal',
  managers_only: 'Solo gerencia',
};

// Shared with the rest of the app; re-exported so this feature's callers and
// tests keep importing them from here.
export { initials, telHref } from 'src/shared/utils/contact';

/**
 * Turns form values into the request body.
 *
 * Blank optional inputs become `null`, not `""`. An empty string is a value:
 * sent as one it would overwrite a phone number with emptiness and then fail
 * the server's format check, where `null` means "she has none".
 */
export const toPayload = (values: {
  firstName: string;
  lastName?: string;
  phone?: string;
  email?: string;
  birthDate?: string;
  notes?: string;
  marketingOptIn: boolean;
  source: ClientSource;
}): ClientPayload => ({
  firstName: values.firstName.trim(),
  lastName: values.lastName?.trim() || null,
  phone: values.phone?.trim() || null,
  email: values.email?.trim() || null,
  birthDate: values.birthDate || null,
  notes: values.notes?.trim() || null,
  marketingOptIn: values.marketingOptIn,
  source: values.source,
});
